// import React from "react";
import "./SportOneW18Cards.scss";
import { useNavigate } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const SportOneW18Cards = () => {
  const { documents: allproducts } = useCollection("products");
  const navigate = useNavigate();

  const colorClasses = [
    "w18-card-blue",
    "w18-card-teal",
    "w18-card-purple",
    "w18-card-pink",
  ];

  const activeProducts =
    allproducts?.filter((doc) => doc.status === "active") || [];

  return (
    <section className="sport-one-w18-cards-section">
      <div className="w18-cards-heading">
        <h2>W18 Services</h2>
        {/* <a href="/services" className="learn-more">View All</a> */}
      </div>
      <br />
      <div className="w18-carousel-wrapper">
        <div className="w18-carousel">
          {activeProducts.slice(0, 6).map((product, index) => {
            const colorClass = colorClasses[index % colorClasses.length];
            return (
              <div
                className={`w18-card ${colorClass}`}
                key={index}
                onClick={() => navigate(`/product-details-two/${product.id}`)}
              >
                <div className="w18-card-content">
                  <div className="w18-card-image">
                    <img
                      src={product.images?.[0] || "/assets/img/placeholder.jpg"}
                      alt={product.name}
                      loading="lazy"
                    />
                  </div>
                  <div className="w18-card-text">
                    <h3>{product.name}</h3>
                    <div className="price-row">
                      <h2>{product.price || "Add Price"}</h2>&nbsp;
                      <strike>{product.discount || "Add Discount"}</strike>
                    </div>
                    <p>{product.short_description}</p>
                    <span>⭐ {product.rating}</span>
                  </div>
                  <div className="arrow-icon">
                    <span style={{ fontSize: "1.2rem" }}>&#8594;</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {activeProducts.length > 6 && (
        <div className="show-more-container">
          <button
            className="show-more-btn"
            onClick={() => navigate("/products-two")}
          >
            Show More
          </button>
        </div>
      )}
    </section>
  );
};

export default SportOneW18Cards;
